/* eslint-disable prettier/prettier */
import * as React from "react"
import { any, fromJSX } from "widgets-for-react"
import { filterCheckboxesList } from "../fake_data/filtersOverlay"
import { formFields, formPanels, formToggles } from "../fake_data/forms"
import { linkBackAnchor, linkBackButton } from "../fake_data/links"
import { pagination } from '../fake_data/pagination'
import { styleguideChapter, styleguideExample, styleguidePart, styleguideSection } from "../helpers.mod"

export const styleguideObjects = styleguideChapter({ type: 'objects', slug: 'objects', title: 'Design Objects', intro: 'If design tokens are the atoms of the design system, design objects are the material — specifically, they what comes after. We use them to make the developer’s job easier and to give the designers some extra insight in their work.' })(
      any([
        styleguideSection({ type: 'objects', slug: 'objects-filters', title: 'Filters', intro: '' })(
          styleguidePart({ title: 'Titles', intro: '' })(
            styleguideExample({ showExampleLabel: false, isFullScreen: false })(
              fromJSX(
                _ => filterCheckboxesList()
              )
            )
          ),
        ),
        styleguideSection({ type: 'objects', slug: 'objects-typography', title: 'Typography', intro: '' })(
          any([
            styleguidePart({ title: 'Titles', intro: '' })(
              styleguideExample({ showExampleLabel: false, isFullScreen: false })(
                fromJSX(
                  _ => (
                    <>
                      <h1 className="title--xl">Title of homepage's header - XL</h1><br /><br />
                      <h1 className="title--l">Title of genaral pages header - L</h1><br /><br />
                      <h2 className="title--m">Integer posuere a ante venenatis - M</h2><br /><br />
                      <h3 className="title--s">Integer posuere erat a ante venenatis - S</h3><br />
                      <h4 className="title--xs">Integer posuere erat a ante venenatis - XS</h4>
                    </>
                  )
                )
              )
            ),
            styleguidePart({ title: 'Texts', intro: '' })(
              styleguideExample({ showExampleLabel: false, isFullScreen: false })(
                fromJSX(
                  _ => (
                    <>
                      <p className="text--l">Integer posuere erat a ante venenatis aliquet. Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. - L</p><br />
                      <p className="text--m">Integer posuere erat a ante venenatis aliquet. Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. - M</p><br />
                      <p className="text--s">Integer posuere erat a ante venenatis aliquet. Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. - S</p><br />
                    </>
                  )
                )
              )
            ),
            styleguidePart({ title: 'Labels', intro: '' })(
              styleguideExample({ showExampleLabel: false, isFullScreen: false })(
                fromJSX(_ => (
                  <p className="label--m">Integer posuere erat a ante venenatis aliquet - M</p>
                ))
              )
            ),
          ])
        ),
        styleguideSection({ type: 'objects', slug: 'objects-buttons', title: 'Buttons', intro: '' })(
          any([
            styleguidePart({ title: 'Primary button', intro: '' })(
              styleguideExample({ showExampleLabel: false, isFullScreen: false })(
                fromJSX(
                  _ => (
                    <>
                      <button className="button button--primary">Lorem ipsum</button>
                      <br />
                      <br />
                      <a href="" className="button button--primary">Lorem ipsum</a>
                      <br />
                      <br />
                      <button className="button button--primary" disabled>Lorem ipsum disabled</button>
                    </>
                  )
                )
              )
            ),
            styleguidePart({ title: 'Secondary button', intro: '' })(
              styleguideExample({ showExampleLabel: false, isFullScreen: false })(
                fromJSX(
                  _ => (
                    <>
                      <button className="button button--secondary">Lorem ipsum</button>
                      <br />
                      <br />
                      <a href="" className="button button--secondary">Lorem ipsum</a>
                      <br />
                      <br />
                      <button className="button button--secondary" disabled>Lorem ipsum disabled</button>
                    </>
                  )
                )
              )
            ),
            styleguidePart({ title: 'Button group', intro: '' })(
              styleguideExample({ showExampleLabel: false, isFullScreen: false })(
                fromJSX(
                  _ => (
                    <div className="button-group">
                      <a href="" className="button button--primary">Button</a>
                      <a href="" className="button button--secondary">Button</a>
                    </div>
                  )
                )
              )
            ),
            styleguidePart({ title: 'Primary button on colored background', intro: '', extraClasses: ' styleguide__part--dark' })(
              styleguideExample({ showExampleLabel: false, isFullScreen: false })(
                fromJSX(_ => (
                    <>
                      <button className="button button--primary--inverted">Lorem ipsum</button>
                      <br />
                      <br />
                      <a href="" className="button button--primary--inverted">Lorem ipsum</a>
                      <br />
                      <br />
                      <button className="button button--primary--inverted" disabled>Lorem ipsum disabled</button>
                    </>
                ))
              )
            ),
            styleguidePart({ title: 'CookiePro button', intro: '', extraClasses: ' styleguide__part--dark' })(
              styleguideExample({ showExampleLabel: false, isFullScreen: false })(
                fromJSX(_ => (
                  <button id="ot-sdk-btn" className="button button--primary--inverted">Cookie-instellingen</button>
                ))
              )
            )
          ])
        ),
        styleguideSection({ type: 'objects', slug: 'objects-links', title: 'Links', intro: '' })(
          any([
            styleguidePart({ title: 'Inline link', intro: '' })(
              styleguideExample({ showExampleLabel: false, isFullScreen: false })(
                fromJSX(_ => (
                  <div className="text--styled">
                    <p>Integer posuere erat a ante venenatis <a href="#">donec ullamcorper nulla</a> aliquet. Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Donec id elit non mi porta gravida at eget metus.</p>
                  </div>
                ))
              )
            ),
            styleguidePart({ title: 'Primary links', intro: '' })(
              styleguideExample({ showExampleLabel: false, isFullScreen: false })(
                fromJSX(_ => (
                  <>
                    <button className="link link--primary">Lorem ipsum</button>
                    <br />
                    <br />
                    <a href="" className="link link--primary">Lorem ipsum</a>
                  </>
                ))
              )
            ),
            styleguidePart({ title: 'Secondary links', intro: '' })(
              styleguideExample({ showExampleLabel: false, isFullScreen: false })(
                fromJSX(_ => (
                  <>
                    <button className="link link--secondary">Lorem ipsum</button>
                    <br />
                    <br />
                    <a href="" className="link link--secondary">Lorem ipsum</a>
                  </>
                ))
              )
            ),
            styleguidePart({ title: 'Link with arrow', intro: '' })(
              styleguideExample({ showExampleLabel: false, isFullScreen: false })(
                fromJSX(_ => (
                  <>
                    <button className="link link--arrow">Lorem ipsum</button>
                    <br />
                    <br />
                    <a href="" className="link link--arrow">Lorem ipsum</a>
                  </>
                ))
              )
            ),
            styleguidePart({ title: 'Link to go back', intro: '' })(
              styleguideExample({ showExampleLabel: false, isFullScreen: false })(
                fromJSX(_ => (
                  <>
                    {linkBackButton()}
                    <br />
                    {linkBackAnchor()}
                  </>
                ))
              )
            ),
            styleguidePart({ title: 'Links list with arrow', intro: '' })(
              styleguideExample({ showExampleLabel: false, isFullScreen: false })(
                fromJSX(_ => (
                  <ul className="list list--arrow">
                    <li>
                      <a href="" className="link">Lorem ipsum</a>
                    </li>
                    <li>
                      <a href="" className="link">Lorem ipsum</a>
                    </li>
                    <li>
                      <a href="" className="link">Lorem ipsum</a>
                    </li>
                  </ul>
                ))
              )
            ),
          ])
        ),
        styleguideSection({ type: 'objects', slug: 'objects-lists', title: 'Lists', intro: '' })(
          any([
            styleguidePart({ title: 'Ordered list (WYSIWYG)', intro: '' })(
              styleguideExample({ showExampleLabel: false, isFullScreen: false })(
                fromJSX(_ => (
                  <div className="text--styled">
                    <ol>
                      <li>Morbi leo risus, <a>porta ac consectetur ac</a>, vestibulum at eros.</li>
                      <li>Aenean lacinia bibendum nulla sed consectetur.</li>
                      <li>Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.
                        <ol>
                          <li>Morbi leo risus, porta ac consectetur ac, vestibulum at eros.</li>
                          <li>Aenean lacinia bibendum nulla sed consectetur.</li>
                        </ol>
                      </li>
                      <li>Nullam quis risus eget urna mollis ornare vel eu leo.</li>
                    </ol>
                  </div>
                ))
              )
            ),
            styleguidePart({ title: 'Unorderd list (WYSIWYG)', intro: '' })(
              styleguideExample({ showExampleLabel: false, isFullScreen: false })(
                fromJSX(_ => (
                  <div className="text--styled">
                    <ul>
                      <li>Morbi leo risus, porta ac consectetur ac, vestibulum at eros.</li>
                      <li>Aenean lacinia bibendum nulla sed consectetur.</li>
                      <li>Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.
                        <ul>
                          <li>Integer consequat sapien a lectus gravida euismod.</li>
                          <li>Integer consequat sapien a lectus gravida euismod.</li>
                        </ul>
                      </li>
                      <li>Nullam quis risus eget urna mollis ornare vel eu leo.</li>
                    </ul>
                  </div>
                ))
              )
            ),
            styleguidePart({ title: 'Expander', intro: '' })(
              styleguideExample({ showExampleLabel: false, isFullScreen: false })(
                fromJSX(
                  _ => (
                    <div className="blocklist__item">
                      <button className="blocklist__link" aria-label="Toggle item">
                        <p className="blocklist__title">Cras Ipsum Fermentum Lorem</p>
                      </button>
                      <br />
                      <br />
                      <button className="blocklist__link blocklist__link--active" aria-label="Toggle item">
                        <p className="blocklist__title">Cras Ipsum Fermentum Lorem</p>
                      </button>
                    </div>
                  )
                )
              )
            ),
          ])
        ),
        styleguideSection({ type: 'objects', slug: 'objects-pagination', title: 'Lists', intro: '' })(
          styleguidePart({ title: 'Pagination', intro: '' })(
            styleguideExample({ showExampleLabel: false, isFullScreen: false })(
              fromJSX((_) => pagination())
            )
          )
        ),
        styleguideSection({ type: 'objects', slug: 'objects-forms', title: 'Forms', intro: 'Controls for the form building block. The Fabric-rendered CMS block reuses the same field, label and panel styling inside its own .ms-* markup, so the dropdown, checkbox, radio and datepicker there still need checking against a real form.' })(
          any([
            styleguidePart({ title: 'Fields', intro: '' })(
              styleguideExample({ showExampleLabel: false, isFullScreen: false })(
                fromJSX((_) => formFields())
              )
            ),
            styleguidePart({ title: 'Checkbox and radio', intro: '' })(
              styleguideExample({ showExampleLabel: false, isFullScreen: false })(
                fromJSX((_) => formToggles())
              )
            ),
            styleguidePart({ title: 'Messages and submit', intro: '' })(
              styleguideExample({ showExampleLabel: false, isFullScreen: false })(
                fromJSX((_) => formPanels())
              )
            ),
          ])
        )
      ])
    )